import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDashboard = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M5.333 17.333h8c0.733 0 1.333-0.6 1.333-1.333v-10.667c0-0.733-0.6-1.333-1.333-1.333h-8c-0.733 0-1.333 0.6-1.333 1.333v10.667c0 0.733 0.6 1.333 1.333 1.333zM5.333 28h8c0.733 0 1.333-0.6 1.333-1.333v-5.333c0-0.733-0.6-1.333-1.333-1.333h-8c-0.733 0-1.333 0.6-1.333 1.333v5.333c0 0.733 0.6 1.333 1.333 1.333zM18.667 28h8c0.733 0 1.333-0.6 1.333-1.333v-10.667c0-0.733-0.6-1.333-1.333-1.333h-8c-0.733 0-1.333 0.6-1.333 1.333v10.667c0 0.733 0.6 1.333 1.333 1.333zM17.333 5.333v5.333c0 0.733 0.6 1.333 1.333 1.333h8c0.733 0 1.333-0.6 1.333-1.333v-5.333c0-0.733-0.6-1.333-1.333-1.333h-8c-0.733 0-1.333 0.6-1.333 1.333z" })
});
export default SvgDashboard;
